import games from '../../api/games'
import Vue from 'vue'


const state = {
    currentGame: null,
    currentGameSummary: null
}

const getters = {
    currentGame: state => {
        return state.currentGame
    },
    winner: state => { return state.currentGame.winner },
    hasWinner: state => { return state.currentGame !== null && state.currentGame.winner !== null},
    isComplete: state => { return state.currentGame === null || state.currentGame.isComplete}
}

const mutations = {
    setGameSummary(state, data) {
        /* eslint-disable no-console */
        console.log('got game summary ' + data.game.id)
        state.currentGameSummary = data.game
    },
    setGame(state, data) {
        /* eslint-disable no-console */
        console.log('got scoresheet for game ' + data.game.id)
        state.currentGame = data.game
    },
    updateGame(state, updatedGame) {
        Vue.set(state.currentGame, 'completedRounds', updatedGame.completedRounds)
        Vue.set(state.currentGame, 'currentRound', updatedGame.currentRound)
        Vue.set(state.currentGame, 'currentScores', updatedGame.currentScores)
        Vue.set(state.currentGame, 'rounds', updatedGame.rounds)
        Vue.set(state.currentGame, 'playerTurn', updatedGame.playerTurn)
        Vue.set(state.currentGame, 'completed', updatedGame.completed)
        Vue.set(state.currentGame, 'winner', updatedGame.winner)
    }
}

const actions = {
    retrieveGame({ commit }, id) {
        games.getGame(id, response => {
            commit('setGameSummary', {game: response.gameSummary}); // JSON are parsed automatically.
            commit('setGame', {game: response.game}); // JSON are parsed automatically.
        }, e => {
            console.log(e);
        });
    },
    /* eslint-disable no-console */
    newGame({ commit }, data) {
        return new Promise((resolve, reject) => {
            games.newGame(data, response => {
                commit('addGame', response);
                resolve(response)
            }, e => {
                reject(e);
            });
        });
    },
    updateScore({ commit }, data) {
        return new Promise((resolve, reject) => {
            games.updateScore(data.id, data, response => {
                games.getGame(data.id, response => {
                    commit('updateGame', response.game)
                    commit('games/updateGame', response.gameSummary, { root: true })
                    resolve(response)
                });
                resolve(response)
            }, e => {
                reject(e);
            });
        });
    },
    playerOut({ commit }, data) {
        return new Promise((resolve, reject) => {
            games.playerOut(data.id, data, response => {
                games.getGame(data.id, response => {
                    commit('updateGame', response.game)
                    commit('games/updateGame', response.gameSummary, { root: true })
                    resolve(response)
                });
                resolve(response)
            }, e => {
                reject(e);
            });
        });
    }
    /* eslint-enable no-console */
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}